window.Buffer = require('buffer/').Buffer // eslint-disable-line @typescript-eslint/no-var-requires
